import Trail              from "../fundamentals/trail/Trail";
import PlanAmount         from "./PlanAmount";
import PlanDayLimit       from "./PlanDayLimit";
import PlanDescription    from "./PlanDescription";
import PlanId             from "./PlanId";
import PlanName           from "./PlanName";
import PlanStatusType     from "./PlanStatusType";
import PlanTaxIncludeType from "./PlanTaxIncludeType";
import PlanTimeType       from "./PlanTimeType";

class Plan {
  constructor(
    private readonly _id: PlanId = new PlanId(),
    private readonly _name: PlanName = new PlanName(),
    private readonly _description: PlanDescription = new PlanDescription(),
    private readonly _amount: PlanAmount = new PlanAmount(),
    private readonly _taxIncludeType: PlanTaxIncludeType = PlanTaxIncludeType.NOT_INCLUDE,
    private readonly _timeType: PlanTimeType = PlanTimeType.MINUTE_30,
    private readonly _statusType: PlanStatusType = PlanStatusType.PRIVATE,
    private readonly _dayLimit: PlanDayLimit = new PlanDayLimit(),
    private readonly _trail: Trail = new Trail()
  ) {
  }

  get id(): PlanId {
    return this._id;
  }

  get name(): PlanName {
    return this._name;
  }

  get description(): PlanDescription {
    return this._description;
  }

  get amount(): PlanAmount {
    return this._amount;
  }

  get taxIncludeType(): PlanTaxIncludeType {
    return this._taxIncludeType;
  }

  get timeType(): PlanTimeType {
    return this._timeType;
  }

  get statusType(): PlanStatusType {
    return this._statusType;
  }

  get dayLimit(): PlanDayLimit {
    return this._dayLimit;
  }

  get trail(): Trail {
    return this._trail;
  }
}

export default Plan;
